import { h } from 'preact';
import { TokenCounter } from '../TokenCounter';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'TokenCounter',
  category: '🏷️ Badges & Indicadores',
  description: 'Contador de tokens in/out por mensagem',
  usedIn: ['ChatHubPage'],
  example: () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <TokenCounter tokensIn={245} tokensOut={1200} costUsd={0.0012} durationMs={1500} />
      <TokenCounter tokensIn={50} tokensOut={300} />
    </div>
  ),
};
